export const Read = 'read';
export const Update = 'update';
export const Create = 'create';
export const Delete = 'delete';
